import posthog from 'posthog-js';

import { env } from '@/lib/env';

let initialized = false;

export function initPostHog() {
  // No key ⇒ no PostHog. An environment may legitimately run before its analytics project is
  // provisioned, and a placeholder key would only fire failing requests on every page.
  if (initialized || typeof window === 'undefined' || !env.VITE_POSTHOG_KEY) return;
  posthog.init(env.VITE_POSTHOG_KEY, {
    api_host: env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: true,
    persistence: 'localStorage+cookie',
    loaded: () => {
      initialized = true;
    },
  });
}

export function identifyUser(userId: string, props?: Record<string, unknown>) {
  if (!initialized) return;
  posthog.identify(userId, props);
}

export function resetIdentity() {
  if (!initialized) return;
  posthog.reset();
}
